export function DashboardSkeleton() {
  return (
    <div className="mx-auto max-w-[1440px] space-y-5 px-4 py-4 lg:px-6 lg:py-5">
      <div className="skeleton-shimmer h-48 rounded-3xl sm:h-56" />
      <div className="skeleton-shimmer h-20 rounded-2xl" />
      <div className="grid gap-3 sm:grid-cols-2 xl:grid-cols-4">
        {[1, 2, 3, 4].map((i) => (
          <div key={i} className="skeleton-shimmer h-36 rounded-2xl" />
        ))}
      </div>
      <div className="grid gap-4 sm:grid-cols-2 xl:grid-cols-3">
        {[1, 2, 3].map((i) => (
          <div key={i} className="skeleton-shimmer h-56 rounded-2xl" />
        ))}
      </div>
      <div className="skeleton-shimmer h-80 rounded-2xl" />
      <div className="grid gap-4 lg:grid-cols-3">
        <div className="skeleton-shimmer h-48 rounded-2xl lg:col-span-2" />
        <div className="skeleton-shimmer h-48 rounded-2xl" />
      </div>
      <div className="skeleton-shimmer h-32 rounded-2xl" />
      <div className="skeleton-shimmer h-44 rounded-2xl" />
    </div>
  )
}
